

















































































import { DealerTelephone } from '~/models/dealer/types'
import CHybridTelephone from '~/components/shared/configurable/telephone/CHybridTelephone.vue'
import { mapState, mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import SellerInfoIcon from '~/components/car/classifieds/view/partials/seller/dealer/SellerInfoIcon.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CHybridTelephone,
    SellerInfoIcon
  },
  props: {
    telephone1: {
      type: Object as PropType<DealerTelephone>,
      default: null
    },
    telephone2: {
      type: Object as PropType<DealerTelephone>,
      default: null
    },
    mobile: {
      type: Object as PropType<DealerTelephone>,
      default: null
    },
    fax: {
      type: Object as PropType<DealerTelephone>,
      default: null
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      classifiedId: state => state.classifiedId
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    telephone1Title() {
      if (this.telephone2) {
        return this.$t('telephone') + ' 1'
      }
      return this.$t('telephone')
    }
  }
})
